import { error } from '@innovyze/stylovyze/lib/actions';
import * as sensorActions from '@innovyze/stylovyze/lib/actions/sensor.actions';
import { fanOutSensorsList } from '@innovyze/stylovyze/lib/services/sensor.service';
import { delay, put, retry, takeLatest } from 'redux-saga/effects';
function* getSensorsListSaga(action) {
    yield delay(100);
    const { getSensorsListResolved, getSensorsListRejected } = sensorActions;
    try {
        const response = yield retry(2, 100000, fanOutSensorsList, action.payload);
        if (response.data?.sensors) {
            yield put(getSensorsListResolved(response.data.sensors));
        }
        else {
            yield put(error('Failed to get sensors, displaying cached data'));
            yield put(getSensorsListRejected());
        }
    }
    catch (e) {
        yield put(error('Failed to get sensors, displaying cached data'));
        yield put(getSensorsListRejected());
    }
}
function* watchGetSensorsListSaga() {
    yield takeLatest(sensorActions.getSensorsList, getSensorsListSaga);
}
export default [watchGetSensorsListSaga()];
